import React from "react";
import HomePage from "./HomePage";
import "./MainPage.css";
import NavBar from "../components/NavBar";
import NavBarSides from "./NavBarSides";
import AboutPage from "./AboutPage";
import ResumePage from "./ResumePage";
import ProjectsPage from "./ProjectsPage";
import ContactPage from "./ContactPage";
import { useMyContext } from "../store/MyContext";

function MainPage(props) {
  const { centralizedState } = useMyContext();
  return (
    <div className="mainPage">
      <NavBar>
        <NavBarSides />
      </NavBar>
      {centralizedState === 1 && <HomePage />}
      {centralizedState === 2 && <AboutPage />}
      {centralizedState === 3 && <ResumePage />}
      {centralizedState === 4 && <ProjectsPage />}
      {centralizedState === 5 && <ContactPage />}
    </div>
  );
}
export default MainPage;
